import { z } from "zod";

import { SORT_OPTION_VALUES } from "../constants/dashboardSortConstants";
import { STATUS_FILTER_VALUES } from "../constants/dashboardStatusConstants";

export const dashboardFilterSchema = z.object({
  statusFilter: z.enum(STATUS_FILTER_VALUES),
  searchQuery: z.string(),
  sortBy: z.enum(SORT_OPTION_VALUES),
});
